module.exports = __webpack_public_path__ + "static/img/3.925ddfd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/3.png
// module id = rniq
// module chunks = 0